/* eslint-disable max-len */
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getUserCompany } from '@zero5/user-api';

import { mapUserCompany } from '@/api/mappings/user';

type Response = ReturnType<typeof mapUserCompany>;
const queryKey: QueryKey = 'userCompanyQuery';

const useUserCompanyQuery = (
  options?: UseQueryOptions<Response, unknown, Response, typeof queryKey>,
) => {
  return useQuery<Response, unknown, Response, typeof queryKey>(
    queryKey,
    async () => {
      const response = await getUserCompany();

      return mapUserCompany(response.company!);
    },
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      ...options,
    },
  );
};

export default useUserCompanyQuery;
